<script>
  import {VARIANT} from '../../constants';
  import classNames from 'classnames';

  export let id = Math.random();
  export let className = '';
  export let checked = false;
  export let value = '';

  const inputId = `scmp_FancyCheckbox-${id}`;
  const checkboxClass = classNames(`scmp_FancyCheckbox${VARIANT}`, className);
  const labelClass = classNames(`scmp_FancyCheckbox${VARIANT}-input`);
</script>

<input on:change id={inputId} bind:value {checked} type="checkbox" class={labelClass} data-dontobserve="true" />
<label for={inputId} class={checkboxClass} />
